import { Component, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core'

@Component({
  selector: 'mp-flowplayer-normal-renderer',
  templateUrl: './flowplayer-normal-renderer.html',
})
export class FlowplayerNormalRendererComponent {
  @Output()
  public shutdown: EventEmitter<boolean> = new EventEmitter<boolean>()

  @ViewChild('playerContainer')
  public playerContainerRef: ElementRef

  public render() {
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/flowplayer/renderers/normal/flowplayer-normal-renderer.component.ts